'use strict';

import Cookies from 'js-cookie';

// 事件行为判定cookie
export function getToken(name) {
	return Cookies.get(name);
}

export function setToken(name, value, data) {
	if (data) {
		return Cookies.set(name, value, { expires: data });
	} else {
		return Cookies.set(name, value);
	}
}

export function removeToken(eventKey) {
	return Cookies.remove(eventKey);
}

// Storage存储
const sessionStorage = window.sessionStorage;
const localStorage = window.localStorage;

// sessionStorage存储封装
export function setSessionStorage(key, val) {
	sessionStorage.setItem(key, val);
}

export function getSessionStorage(key) {
	return sessionStorage.getItem(key);
}
export function removesessionStorage(key) {
	return sessionStorage.removeItem(key);
}

// localStorage存储封装
export function setLocalStorage(key, val) {
	localStorage.setItem(key, val);
}
export function getLocalStorage(key) {
	return localStorage.getItem(key);
}
export function removeLocalStorage(key) {
	return localStorage.removeItem(key);
}

// export function csvToJson(filePath) {
// 	let result = [];
// 	var xhr = new XMLHttpRequest();
// 	xhr.open('GET', filePath, false);
// 	xhr.onload = function (e) {
// 		if (xhr.readyState === 4) {
// 			if (xhr.status === 200) {
// 				result = csvJSON(xhr.responseText);
// 			} else {
// 				console.error(xhr.statusText);
// 			}
// 		}
// 	};
// 	xhr.send(null);
// 	return result;
// }
// export function csvJSON(csv) {
// 	var lines = csv.split('\n');

// 	var result = [];

// 	var headers = lines[0].split(',');

// 	for (var i = 1; i < lines.length; i++) {
// 		var obj = {};
// 		var currentline = lines[i].split(',');

// 		for (var j = 0; j < headers.length; j++) {
// 			obj[headers[j]] = currentline[j];
// 		}

// 		result.push(obj);
// 	}

// 	return result;
// }
